/* unplugin-vue-components disabled */import script from "./CrsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CrsBlock.vue?vue&type=script&setup=true&lang=js"

import "./CrsBlock.vue?vue&type=style&index=0&id=1119fa7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1119fa7a"]])

export default __exports__